import React from 'react';

/* Material UI */
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

/* Project */
import colors from 'utils/colors';
import footerStyles from './footer.styles';

function Footer() {
  const linkStyle = {
    textDecoration: 'none',
    color: '#002855',
    fontWeight: 500,
    cursor: 'pointer',
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      sx={{
        ...footerStyles.footer,
        backgroundColor: 'rgb(244, 244, 244)',
        paddingBottom: 2,
      }}
    >
      <Grid
        item
        sx={{
          width: '100%',
          borderBottom: `1px solid ${colors.blue || '#002855'}`,
          marginBottom: 2,
        }}
      />

      <Grid
        container
        item
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          justifyContent: { xs: 'center', md: 'space-between' },
          alignItems: 'center',
          gap: { xs: 2, md: 0 },
          paddingX: { xs: 2, md: 4 },
        }}
      >
        <Grid item>
          <Typography
            color="primary"
            variant="subtitle2"
            sx={{ color: '#002855', fontWeight: 'bold' }}
          >
            Salfa | Todos los derechos reservados
          </Typography>
        </Grid>

        <Grid
          item
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 1,
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" sx={footerStyles.infoText}>
            <a
              href="https://www.salfaautomotriz.cl/es/bases-legales"
              style={linkStyle}
              target="_blank"
              rel="noreferrer"
            >
              Términos y condiciones
            </a>
          </Typography>

          <Typography variant="caption" sx={{ color: '#002855' }}>•</Typography>

          <Typography variant="caption" sx={footerStyles.infoText}>
            <a href="#" style={linkStyle}>
              Política de Cookies
            </a>
          </Typography>

          <Typography variant="caption" sx={{ color: '#002855' }}>•</Typography>

          <Typography variant="caption" sx={footerStyles.infoText}>
            <a href="#" style={linkStyle}>
              Política de Privacidad
            </a>
          </Typography>

           <Typography variant="caption" sx={{ color: '#002855' }}>•</Typography>
           
           <Typography variant="caption" sx={footerStyles.infoText}>
            <a href="#" style={linkStyle}>
              Bases legales
            </a>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Footer;